import i18n from '../services/i18n';
import {application} from './configs';
// import {store} from '../AppRenderer';

const getMenuItems = statistics => ([
  {
    id: 'analytics',
    icon: 'icon-Statistic',
    label: i18n.t('Analytics'),
    to: '/dashboard/analytics',
    subs: [
      {
        label: i18n.t('Exchange Assets Report'),
        to: '/dashboard/analytics/exchangeAssetsReport',
        permission: 'view_statistics',
      },
      {
        label: i18n.t('Users Activity Report'),
        to: '/dashboard/analytics/activityReport',
        permission: 'view_statistics',
      },
      {
        label: i18n.t('Users Balance Report'),
        to: '/dashboard/analytics/usersBalanceReport',
        permission: 'view_statistics',
      },
      {
        label: i18n.t('Users Fee Report'),
        to: '/dashboard/analytics/usersFeeReport',
        permission: 'view_statistics',
      },
      {
        label: i18n.t('Charts'),
        to: '/dashboard/analytics/charts',
        permission: 'view_statistics',
      },
    ],
  },
  // {
  //   id: 'analytics',
  //   show: true,
  //   icon: 'icon-Bar-Chart',
  //   label: i18n.t('Analytics'),
  //   to: '/dashboard/analytics/all',
  //   subs: store.getState().app.financialGroups.length ?
  //     [
  //       {
  //         label: i18n.t('All'),
  //         to: '/dashboard/analytics/all',
  //         permission: 'view_statistics',
  //       },
  //       ...store.getState().app.financialGroups.map(group => (
  //       {
  //         label: group.name,
  //         to: `/dashboard/analytics/${group.name}`,
  //         permission: 'view_statistics',
  //       }
  //     ))] :
  //     [{
  //       to: '/dashboard/analytics/all',
  //       permission: 'view_statistics',
  //     }]
  // },
  {
    id: 'users',
    icon: 'icon-User',
    label: i18n.t('Users'),
    to: '/dashboard/users',
    subs: [
      {
        to: '/dashboard/users/list',
      },
    ],
  },
  {
    id: 'zarinpal-transfers',
    icon: 'icon-User',
    label: i18n.t('Zarinpal Transfers'),
    show: application.platformName === 'zarindax',
    to: '/dashboard/zarinpal-transfers',
    subs: [
      {
        to: '/dashboard/zarinpal-transfers',
      },
    ],
  },
  {
    id: 'kyc',
    icon: 'icon-Professor',
    label: i18n.t('Kyc'),
    to: '/dashboard/kyc',
    count: statistics ? statistics.submittedKycCount : null,
    subs: [
      {
        label: i18n.t('All'),
        to: '/dashboard/kyc/all',
        permission: 'view_kyc-list',
      },
      {
        label: i18n.t('Registered'),
        to: '/dashboard/kyc/registered',
        permission: 'view_kyc-list',
        count: statistics ? statistics.submittedKycCount : null,
      },
    ],
  },
  {
    id: 'bankAccounts',
    show: application.platformName !== 'zarindax',
    icon: 'icon-Credit-Card2',
    label: i18n.t('Bank Accounts'),
    to: '/dashboard/bankAccounts',
    count: statistics ? statistics.pendingBankAccountsCount : null,
    subs: [
      {
        label: i18n.t('All'),
        to: '/dashboard/bankAccounts/all',
        permission: 'view_bank-accounts-list',
      },
      {
        label: i18n.t('Pending'),
        to: '/dashboard/bankAccounts/pending',
        permission: 'view_bank-accounts-list',
      },
    ],
  },
  {
    id: 'cardNumbers',
    show: application.platformName === 'zarindax',
    icon: 'icon-Credit-Card2',
    label: i18n.t('Card Numbers'),
    to: '/dashboard/cardNumbers',
    count: statistics && statistics.pendingKYCVerifiedBankAccountsCount && statistics.pendingKYCVerifiedBankAccountsCount.cardNumberCount ? statistics.pendingKYCVerifiedBankAccountsCount.cardNumberCount : null,
    subs: [
      {
        label: i18n.t('All'),
        to: '/dashboard/cardNumbers/all',
        permission: 'view_bank-accounts-list',
      },
      {
        label: i18n.t('Pending'),
        to: '/dashboard/cardNumbers/pending',
        permission: 'view_bank-accounts-list',
      },
    ],
  },
  {
    id: 'ibanNumbers',
    show: application.platformName === 'zarindax',
    icon: 'icon-Credit-Card3',
    label: i18n.t('Iban  Numbers'),
    to: '/dashboard/ibanNumbers',
    count: statistics && statistics.pendingKYCVerifiedBankAccountsCount && statistics.pendingKYCVerifiedBankAccountsCount.ibanCount ? statistics.pendingKYCVerifiedBankAccountsCount.ibanCount : null,
    subs: [
      {
        label: i18n.t('All'),
        to: '/dashboard/ibanNumbers/all',
        permission: 'view_bank-accounts-list',
      },
      {
        label: i18n.t('Pending'),
        to: '/dashboard/ibanNumbers/pending',
        permission: 'view_bank-accounts-list',
      },
    ],
  },
  {
    id: 'deposits',
    icon: 'icon-Down-4 icon-Coins',
    label: i18n.t('Deposits'),
    to: '/dashboard/deposits',
    count: statistics ? statistics.notVerifiedBankDepositsCounts : null,
    subs: [
      {
        label: i18n.t('All'),
        to: '/dashboard/deposits/all',
        permission: 'view_deposits-list',
      },
      {
        label: i18n.t('Bank Deposits'),
        to: '/dashboard/deposits/bank',
        permission: 'view_bank-deposit',
        show: application.supportV2,
      },
      {
        label: i18n.t('Not Verified Toman Deposits'),
        to: '/dashboard/deposits/notVerified',
        count: statistics ? statistics.notVerifiedBankDepositsCounts : null,
        permission: 'view_deposits-list',
      },
      {
        label: i18n.t('Blocked Toman Deposits'),
        to: '/dashboard/deposits/blocked',
        count: statistics ? statistics.blockedBankDepositsCount : null,
        permission: 'view_deposits-list',
      },
      {
        label: i18n.t('Failed Toman Deposits'),
        to: '/dashboard/deposits/failed',
        permission: 'view_deposits-list',
      },
      {
        label: i18n.t('Id Base Deposits'),
        to: '/dashboard/deposits/idBase',
        permission: 'view_bank-deposit',
      },
      {
        label: i18n.t('Payment IDs'),
        to: '/dashboard/deposits/paymentIds',
        permission: 'view_bank-deposit',
      },
    ],
  },
  {
    id: 'withdraws',
    icon: 'icon-Up-4 icon-Coins',
    label: i18n.t('Withdraws'),
    to: '/dashboard/withdraws',
    count: statistics ? statistics.acceptedBankWithdrawsCount + statistics.acceptedCryptoWithdrawsCount : null,
    subs: [
      {
        label: i18n.t('All'),
        to: '/dashboard/withdraws/all',
        permission: 'view_withdraws-list',
      },
      {
        label: i18n.t('Waiting'),
        to: '/dashboard/withdraws/waiting',
        permission: 'view_withdraws-list',
        count: statistics ? statistics.acceptedBankWithdrawsCount + statistics.acceptedCryptoWithdrawsCount : null,
      },
      {
        label: i18n.t('Registered'),
        to: '/dashboard/withdraws/registered',
        permission: 'view_withdraws-list',
        count: statistics ? statistics.submittedBankWithdrawsCount + statistics.submittedCryptoWithdrawsCount : null,
      },
      {
        label: i18n.t('Pending'),
        to: '/dashboard/withdraws/pending',
        permission: 'view_withdraws-list',
        count: statistics ? statistics.pendingBankWithdrawsCount + statistics.pendingCryptoWithdrawsCount: null,
      },
      {
        label: i18n.t('Unconfirmed Requests'),
        to: '/dashboard/withdraws/unconfirmedRequests',
        permission: 'view_unconfirmed-withdraws-list',
        count: statistics ? statistics.unconfirmedWithdrawsCount : null,
      },
    ],
  },
  {
    id: 'notices',
    icon: 'icon-Speaker-2',
    label: i18n.t('Notices'),
    to: '/dashboard/notifications',
    subs: [
      {
        label: i18n.t('All'),
        to: '/dashboard/notifications/all',
        permission: 'view_notification',
        show: application.supportV2,
      },
      {
        label: i18n.t('Announcements'),
        to: '/dashboard/notifications/announcement',
        permission: 'view_notification',
        show: application.supportV2,
      },
      {
        label: i18n.t('Declarations'),
        to: '/dashboard/notifications/declaration',
        permission: 'view_notification',
        show: application.supportV2,
      },
      {
        label: i18n.t('Events'),
        to: '/dashboard/notifications/event',
        permission: 'view_notification',
        show: application.supportV2,
      },
      {
        label: i18n.t('Notification'),
        to: '/dashboard/notifications/actions',
        permission: 'view_general-notifications',
        show: !application.supportV2,
      },
      {
        label: i18n.t('Group SMS'),
        to: '/dashboard/notifications/groupSMS',
        permission: 'view_group-message',
        show: !application.supportV2,
      },
      {
        label: i18n.t('Group Email'),
        to: '/dashboard/notifications/groupEmail',
        permission: 'view_group-message',
        show: false,
      },
    ]
  },
  {
    id: 'alerts',
    show: application.supportV2,
    icon: 'icon-Alarm',
    label: i18n.t('Alerts'),
    to: '/dashboard/alerts',
    subs: [
      {
        to: '/dashboard/alerts/list',
        permission: 'view_user-alerts',
      }
    ]
  },
  {
    id: 'score-board',
    show: application.supportV2,
    icon: 'icon-Windows-2',
    label: i18n.t('Campaign Boards'),
    to: '/dashboard/campaigns',
    subs: [
      {
        to: '/dashboard/campaigns/list',
        permission: 'view_boards',
      }
    ]
  },
  {
    id: 'gift-card',
    show: application.supportV2,
    icon: 'icon-Gift-Box',
    label: i18n.t('Gift Cards'),
    to: '/dashboard/giftCards',
    subs: [
      {
        to: '/dashboard/giftCards/list',
        permission: 'view_gift',
      }
    ]
  },
  {
    id: 'bonus-card',
    show: application.supportV2,
    icon: 'icon-Pricing',
    label: i18n.t('Bonus Cards'),
    to: '/dashboard/bonusCards',
    subs: [
      {
        to: '/dashboard/bonusCards/list',
        permission: 'view_bonus-policy',
      }
    ]
  },
  // {
  //   id: 'trading-bot',
  //   show: application.supportV2,
  //   icon: 'icon-Mixer',
  //   label: i18n.t('Trading Bots'),
  //   to: '/dashboard/tradingBots',
  //   subs: [
  //     {
  //       label: i18n.t('Bots List'),
  //       to: '/dashboard/tradingBots/list',
  //       permission: 'view_trading-bot',
  //     },
  //     {
  //       label: i18n.t('Bots Funds'),
  //       to: '/dashboard/tradingBots/wallets',
  //       permission: 'view_trading-bot',
  //     },
  //     {
  //       label: i18n.t('Bots status'),
  //       to: '/dashboard/tradingBots/status',
  //       permission: 'view_trading-bot',
  //     },
  //     {
  //       label: i18n.t('Bots statistics'),
  //       to: '/dashboard/tradingBots/statistics',
  //       permission: 'view_trading-bot',
  //     },
  //   ],
  // },
  {
    id: 'tickets',
    icon: 'icon-Mail-Reply',
    label: i18n.t('Tickets'),
    to: '/dashboard/tickets',
    count: statistics ? statistics.pendingTicketsCount : null,
    subs: [
      {
        label: i18n.t('All'),
        to: '/dashboard/tickets/all',
        permission: 'view_tickets',
      },
      {
        label: i18n.t('Waiting for answer'),
        to: '/dashboard/tickets/waiting-for-answer',
        permission: 'view_tickets',
        count: statistics ? statistics.pendingTicketsCount : null,
      },
      {
        label: `${i18n.t('Replied')} / ${i18n.t('Closed')}`,
        to: '/dashboard/tickets/replied-or-closed',
        permission: 'view_tickets',
      },
    ],
  },
  {
    id: 'reports',
    icon: 'icon-Monitoring',
    label: i18n.t('Reports'),
    to: '/dashboard/reports',
    subs: [
      // {
      //   label: i18n.t('Trade History'),
      //   to: '/dashboard/reports/tradeHistory',
      //   permission: 'view_exchange-trades',
      //   subs: store.getState().app.financialGroups.length ?
      //     [
      //       {
      //         label: i18n.t('All'),
      //         to: '/dashboard/reports/tradeHistory/list/all',
      //         permission: 'view_exchange-trades',
      //       },
      //       ...store.getState().app.financialGroups.map(group => (
      //         {
      //           label: group.name,
      //           to: `/dashboard/reports/tradeHistory/list/${group.name}`,
      //           permission: 'view_exchange-trades',
      //         }
      //       ))] :
      //     [{
      //       to: '/dashboard/reports/tradeHistory/list/all',
      //       permission: 'view_exchange-trades',
      //     }]
      // },
      {
        label: i18n.t('Trade History'),
        to: '/dashboard/reports/tradeHistory',
        permission: 'view_exchange-trades',
      },
      {
        label: i18n.t('User Assets'),
        to: '/dashboard/reports/userAssets',
        permission: 'view_user-assets',
      },
      {
        label: i18n.t('Login History'),
        to: '/dashboard/reports/loginHistory',
        permission: 'view_user-activities',
      },
    ],
  },
  {
    id: 'management',
    icon: 'icon-Settings-Window',
    label: i18n.t('Exchange Management'),
    to: '/dashboard/management',
    subs: [
      {
        label: i18n.t('Tokens'),
        to: '/dashboard/management/tokens',
        permission: 'view_exchange-management',
      },
      {
        label: i18n.t('Pairs'),
        to: '/dashboard/management/pairs',
        permission: 'view_exchange-management',
      },
      {
        label: i18n.t('Tags'),
        to: '/dashboard/management/tags',
        permission: 'view_tag',
        show: application.supportV2,
      },
      {
        label: i18n.t('Zones'),
        to: '/dashboard/management/zones',
        permission: 'view_zone',
        show: application.supportV2,
      },
    ],
  },
  {
    id: 'settings',
    icon: 'icon-Gear',
    label: i18n.t('Settings'),
    to: '/dashboard/settings',
    subs: [
      {
        label: i18n.t('Roles'),
        to: '/dashboard/settings/roles',
        permission: 'view_rbac update_rbac',
      },
      {
        label: i18n.t('Admins'),
        to: '/dashboard/settings/admins',
        permission: 'view_admin-users create_admin-users',
      },
      {
        label: i18n.t('Gateways'),
        to: '/dashboard/settings/gateways',
        permission: 'view_gateways',
      },
      {
        label: i18n.t('Mail Server'),
        to: '/dashboard/settings/mailServer',
        permission: 'view_mail-transport',
      },
      {
        label: i18n.t('User Groups'),
        to: '/dashboard/settings/userGroups',
        permission: 'view_user-groups',
      },
      {
        label: i18n.t('Trade Fee Policies'),
        to: '/dashboard/settings/tradeFeePolicies',
        permission: 'view_policies',
      },
      {
        label: i18n.t('Kyc Policies'),
        to: '/dashboard/settings/kycPolicies',
        permission: 'view_policies',
      },
      {
        label: i18n.t('System Notifications'),
        to: '/dashboard/settings/notifications',
        show: application.supportV2,
      },
      {
        label: i18n.t('Id Base Deposit'),
        to: '/dashboard/settings/idBaseDeposit',
        show: application.supportV2,
        permission: 'view_idBaseDeposit-settings',
      },
    ],
  },
]);

export default getMenuItems;
